import controller from './general-information.controller';

const template = require('./general-information.html');

export default {
    bindings: {
        isEditing: '<',
        location: '<',
        pushData: '&'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/general-information/general-information.component.js